import { api } from './api';

export const falModelsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFalModelsList: builder.query({
      query: (params = {}) => ({
        url: '/admin/fal-models',
        params:
          params.category != null && String(params.category).trim() !== ''
            ? { category: String(params.category).trim() }
            : {},
      }),
      /** Must differ per category or RTK can serve stale unfiltered cache for filtered args. */
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const raw = queryArgs?.category;
        const cat =
          raw != null && String(raw).trim() !== ''
            ? String(raw).trim()
            : '';
        return `${endpointName}(category:${cat})`;
      },
      transformResponse: (response) => {
        const r = response ?? {};
        return {
          models: Array.isArray(r.data) ? r.data : [],
          categories: Array.isArray(r.categories)
            ? r.categories
            : Array.isArray(r.meta?.categories)
              ? r.meta.categories
              : [],
        };
      },
      providesTags: ['FalModel'],
    }),
    updateFalModelStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/admin/fal-models/${id}/status`,
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: ['FalModel'],
    }),
    updateFalModelDetails: builder.mutation({
      query: ({ id, model_name, order, description }) => ({
        url: `/admin/fal-models/${id}`,
        method: 'PATCH',
        body: { model_name, order, description },
      }),
      invalidatesTags: ['FalModel'],
    }),
    updateFalModelDefault: builder.mutation({
      query: ({ id, is_default }) => ({
        url: `/admin/fal-models/${id}/default`,
        method: 'PATCH',
        body: { is_default },
      }),
      invalidatesTags: ['FalModel'],
    }),
  }),
});

export const {
  useGetFalModelsListQuery,
  useUpdateFalModelStatusMutation,
  useUpdateFalModelDetailsMutation,
  useUpdateFalModelDefaultMutation,
} = falModelsApi;
